import React from 'react'
import { useTranslation } from '~/hooks/useTranslation'
import { Modal, Stack } from '~/components/_layouts'
import { useBenefits } from '../BenefitsProvider'
import { Button } from '~/components/_atoms/index'

const CloseReviewDialog = () => {
  const {
    resumeReview,
    onDeclineRevisionClick,
    showCloseReviewDialog,
    toggleCloseReviewDialog,
  } = useBenefits()
  const { t } = useTranslation('confirm_close_dialog')

  const confirmCloseReview = () => onDeclineRevisionClick(resumeReview.id)
  return (
    <Modal
      title={
        <Stack direction="row" spacing={2}>
          {t('title')}
        </Stack>
      }
      size="md"
      open={showCloseReviewDialog}
      onClose={toggleCloseReviewDialog}
      variant="secondary"
      actions={
        <div className="flex w-full gap-4">
          <Button onClick={confirmCloseReview} color="secondary">
            {t('confirm')}
          </Button>
          <Button
            onClick={toggleCloseReviewDialog}
            color="secondary"
            variant="outline"
          >
            {t('cancel')}
          </Button>
        </div>
      }
    >
      {t('description')}
    </Modal>
  )
}

export default CloseReviewDialog
